export const apiUrls = {
    "user_survey": "user_survey/",


    

    //surveyLog
    "survey_log": "surveyLog/",
    "edit_survey_log": "surveyLog/",
    "survey_log_detail": "surveyLog/",
    "create_survey_log": "surveyLog/store",

    //surveyLogDone
    "create_question_done": "surveyLogQuestionDone/store",
    "question_done": "surveyLogQuestionDone/",
    "delete_question_done": "surveyLogQuestionDone/",


    //answer
    "answer_detail": "survey/answer/",

    //joomla
    "joomla_contents_from_tag_titles": "joomla/getAllJoomlaContentsFromTagTitles",
    "joomla_faqs_by_faq_ids": "joomla/getFaqbookproContentByIds",

    //user
    "user_detail": "users/",

    //ticket
    "create_ticket": "ticket/store",
    "ticket_detail": "ticket/",
    "check_ticket_activation": "ticket/activate",
    //ticketAttachments
    "create_ticket_attachments": "tickets/ticketAttachments/store",
    "download_ticket_attachment_file": "tickets/ticketAttachments/download/",
    

    //answerShowInput
    "answerShowInput_detail": "",
}